import Row from './row';
import Col from './col';

export {
  Row,
  Col,
};



// WEBPACK FOOTER //
// ./_antd1.11.2/layout/index.jsx